import './PublicDashboardDetailsPage.css';

import { useParams } from 'react-router-dom';
import { Box } from '@mui/material';
import useGettingPublicDashboard from '../hooks/useGettingPublicDashboard';
import useGettingPublicDashboardInfo from '../hooks/useGettingPublicDashboardInfo';
import { useEffect, useState } from 'react';
import EditText from '../../b2b-common/EditText';
import CustomButton from '../../b2b-common/CustomButton';
import useB2BTranslation from '../../b2b-common/hooks/useB2BTranslation';
import DashboardGrid from '../components/DashboardGrid';
import Banner from '../../b2b-common/Banner';

const PublicDashboard = ({ obfuscatedDashboardId, password = null }) => {
    const { publicDashboard, isLoading } = useGettingPublicDashboard(obfuscatedDashboardId, password);
    if (isLoading) {
        return <div>Loading...</div>;
    }
    if (!publicDashboard) {
        return <div>Dashboard not found</div>;
    }

    const { rows, columns } = publicDashboard.dashboardConfig;

    return (
        <Box display={'flex'} flexDirection={'column'} width={'100%'} height={'100%'} p={5} boxSizing={'border-box'} gap={5} >
            <Banner message={publicDashboard.dashboardName} />
            <DashboardGrid rows={rows} columns={columns} widgets={publicDashboard.widgets}
                isPublicDashboard={true} password={password} />
        </Box>
    );    
}

const PublicDashboardDetailsPage = () => {
    const { dashboardId: obfuscatedDashboardId } = useParams();
    const { publicDashboardInfo, isLoading } = useGettingPublicDashboardInfo(obfuscatedDashboardId);
    const { t } = useB2BTranslation('b2b-reporting');

    const [shouldFetchDashb, setShouldFetchDashb] = useState(false);
    const [form, setForm] = useState({password: null});
    const [isPasswordRequired, setIsPasswordRequired] = useState(null);
    const [showPasswordModal, setShowPasswordModal] = useState(false);

    useEffect(() => {
        if (publicDashboardInfo && publicDashboardInfo.dashboardPassword) {
            setIsPasswordRequired(true);
            setShowPasswordModal(true);
        } else if (publicDashboardInfo && !publicDashboardInfo.dashboardPassword) {
            setIsPasswordRequired(false);
            setShouldFetchDashb(true);
        }
    }, [publicDashboardInfo]);

    if (isLoading) {
        return <div>Loading Info...</div>;
    }
    console.log('publicDashboardInfo: ', publicDashboardInfo);
    if (!publicDashboardInfo) {
        return <div>Dashboard information not found</div>;
    }

    const handlePasswordSubmit = (e) => {
        e.preventDefault();
        setIsPasswordRequired(false);
        setShouldFetchDashb(true);
        setShowPasswordModal(false);
    };    

    if (showPasswordModal && isPasswordRequired) {
        return (
            <Box pt={5}
                className="public-dashboard-page" display={'flex'} flexDirection={'column'}
                width={'100%'} height={'100%'} justifyContent={'center'} alignItems={'center'}
            >
                <h2>{t('This dashboard is key protected')}</h2>
                <Box className="password-field" pt={2}>
                    <EditText label={t('Password')}
                        object={form}
                        setObjectField={setForm}
                        objectField={'password'}
                        type='password'
                    />
                    <CustomButton label={t('Submit')} onClick={handlePasswordSubmit} />
                </Box>
                <p>{t('If you don\'t know the pass key, please contact your site administrator.')}</p>
            </Box>
        );
    }


    if (shouldFetchDashb) {
        return (<PublicDashboard obfuscatedDashboardId={obfuscatedDashboardId} password={form.password} />);    
    }

}

export default PublicDashboardDetailsPage;
